import {Chip, Typography, Stack, Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useTranslator} from "../../context/TranslatorContext";
import {useState} from "react";

export default function PrivacyDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [open, setOpen] = useState(false);
  const {messages} = useTranslator();
  const {mappings, defaultLanguage, topLabel, personalDataIncluded, perDetails,
    sensitiveDataIncluded, senDetails, anonymized, anDetails,
    hasTechnicalOrganisationalMeasure, dataProtectionPrincipleApplied} = props;

  // console.log(dataProtectionPrincipleApplied);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  // console.log(props);

  return (
    <Stack sx={{pt: 1}} spacing={1}>
      {/* Pivot Language Heading */}
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {!isEmpty(personalDataIncluded.getValue(defaultLanguage)) && (<div>
        <Typography variant="body2" className={"key"}>
          {getLabel(keys.personalDataIncluded, "personalDataIncluded")}
        </Typography>
        <Chip label={getLabel(personalDataIncluded.getValue())} sx={{fontWeight: "600"}} />
        {/* <Typography variant="body1">{getLabel(personalDataIncluded.getValue())}</Typography> */}
      </div>)}
      {!isEmpty(perDetails.getValue(defaultLanguage)) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.personalDataDetails, "personalDataDetails")}
          </Typography>
          <Typography variant="body1">{perDetails.getValue(defaultLanguage)}</Typography>
        </div>
      )}
      {!isEmpty(sensitiveDataIncluded.getValue(defaultLanguage)) && (<div>
        <Typography variant="body2" className={"key"}>
          {getLabel(keys.sensitiveDataIncluded, "sensitiveDataIncluded")}
        </Typography>
        <Chip label={getLabel(sensitiveDataIncluded.getValue())} sx={{fontWeight: "600"}} />
      </div>)}
      {!isEmpty(senDetails.getValue(defaultLanguage)) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.sensitiveDataDetails, "sensitiveDataDetails")}
          </Typography>
          <Typography variant="body1">{senDetails.getValue(defaultLanguage)}</Typography>
        </div>
      )}
      <div>
        <Typography variant="body2" className={"key"}>
          {getLabel(keys.anonymized, "anonymized")}
        </Typography>
        <Chip label={getLabel(anonymized.getValue())} sx={{fontWeight: "600"}} />
      </div>
      {!isEmpty(anDetails.getValue(defaultLanguage)) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.anonymizationDetails, "anonymizationDetails")}
          </Typography>
          <Typography variant="body1">{anDetails.getValue(defaultLanguage)}</Typography>
        </div>
      )}
      {(!hasTechnicalOrganisationalMeasure.isEmpty() || !dataProtectionPrincipleApplied.isEmpty()) &&
        <div>
          <Button variant="outlined" size="small" onClick={handleClickOpen}>
            {messages.landing_page_show_privacy}
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}>
            <DialogTitle><Typography variant="h4">
              {messages.landing_page_show_privacy}
            </Typography></DialogTitle>
            <DialogContent>
              {!hasTechnicalOrganisationalMeasure.isEmpty() && (
                <div>
                  <Typography variant="body2" className={"key"} sx={{pt: 1}}>
                    {getLabel(keys.hasTechnicalOrganisationalMeasure, "hasTechnicalOrganisationalMeasure")}
                  </Typography>
                  {hasTechnicalOrganisationalMeasure.getList().map((item, index) => (
                    <div key={index}>
                      {getLabel(item.getValue(), "")}
                    </div>
                  ))}
                </div>
              )}
              {!dataProtectionPrincipleApplied.isEmpty() && (
                <div style={{paddingTop: "0.5em"}}>
                  <Typography variant="body2" className={"key"}>
                    {getLabel(keys.dataProtectionPrincipleApplied, "dataProtectionPrincipleApplied")}
                  </Typography>
                  {dataProtectionPrincipleApplied.getList().map((item, index) => (
                    <div key={index}>
                      {getLabel(item.getValue(), "")}
                    </div>
                  ))}
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>{messages.close_message}</Button>
            </DialogActions>
          </Dialog>
        </div>
      }
    </Stack>
  );
}
